import "./styles.css";
import { RapidRefugeesGame } from "./game/Game";
import { renderStore } from "./store";

const app = document.querySelector<HTMLElement>("#app");
if (!app) throw new Error("Application root is missing");

if (location.pathname.startsWith("/store")) {
  document.title = "Rapid Refugees on Steam";
  renderStore(app);
} else {
  app.innerHTML = `
    <main class="game-shell" data-state="menu">
      <header class="game-header">
        <a class="mini-brand" href="/" aria-label="Rapid Refugees home"><span>🛶</span> RAPID REFUGEES</a>
        <div class="header-actions">
          <a href="/store">STORE</a>
          <button id="sound-button" type="button" aria-label="Mute sound">◖))</button>
          <button id="fullscreen-button" type="button" aria-label="Fullscreen">⛶</button>
          <button id="pause-button" type="button" aria-label="Pause">Ⅱ</button>
        </div>
      </header>
      <section class="game-stage" aria-label="Rapid Refugees game">
        <canvas id="game-canvas" aria-label="Mediterranean coastline. Grab boat passengers and throw them back out to sea."></canvas>
        <div class="court-status" aria-live="polite"><span id="mode">Coast Watch</span><b>PATROL <i id="clock">0:00</i></b></div>
        <div class="hud" aria-live="polite">
          <div><span>SCORE</span><strong id="score">00</strong></div>
          <div><span>COMBO</span><strong id="combo">—</strong></div>
          <div class="time-box"><span>BEACH</span><strong id="lives">♥♥♥</strong></div>
          <div><span>BEST</span><strong id="best">00</strong></div>
        </div>
        <div id="game-overlay" class="game-overlay"></div>
      </section>
      <footer class="game-footer">
        <span>Splash them past the buoy line · Three landings and the beach is theirs</span>
        <span><kbd>P</kbd> pause <kbd>M</kbd> mute</span>
      </footer>
    </main>
  `;

  const required = <T extends Element>(selector: string): T => {
    const element = app.querySelector<T>(selector);
    if (!element) throw new Error(`Required element is missing: ${selector}`);
    return element;
  };

  new RapidRefugeesGame({
    shell: required(".game-shell"),
    canvas: required("#game-canvas"),
    overlay: required("#game-overlay"),
    score: required("#score"),
    combo: required("#combo"),
    lives: required("#lives"),
    best: required("#best"),
    clock: required("#clock"),
    pauseButton: required("#pause-button"),
    soundButton: required("#sound-button"),
    fullscreenButton: required("#fullscreen-button"),
  });
}
